import {
  getFirestoreItemsByQueries,
  type Filter,
} from '../api/getFirestoreItemByQuery.ts';
import { COLLECTIONS } from '../constants';
import { useQuery } from '@tanstack/react-query';

export const useGetFirestoreItemsByQuery = (
  filters: Filter[],
  collectionName: string = COLLECTIONS.listings,
) => {
  return useQuery({
    queryKey: [collectionName, filters],
    queryFn: () => getFirestoreItemsByQueries(filters, collectionName),
  });
};
